module.exports = __webpack_public_path__ + "img/5.11a983b2.jpg";